import { map } from 'rxjs/operators';
import { Component, inject } from '@angular/core';
import { LanguageFlagsUrls } from '@config/language-flags.config';
import { MarketplaceStoreSelector } from '@common/selectors/marketplace.selector';
import { ChangeLangHandlerService } from '@core/services/i18n/change-lang-handler.service';

@Component({
  selector: 'app-kiosk-select-language-block',
  templateUrl: './kiosk-select-language-block.component.html',
  providers: [ChangeLangHandlerService],
})
export class KioskSelectLanguageBlockComponent {
  private readonly changeLangService = inject(ChangeLangHandlerService);
  private readonly marketplaceStoreSelector = inject(MarketplaceStoreSelector);

  private readonly locales$ = this.marketplaceStoreSelector.selectMarketplaceLocales;
  protected readonly languages$ = this.locales$.pipe(
    map(locales =>
      locales.length > 1 
        ? locales.map(language => ({
            locale: language.locale,
            flagUrl: LanguageFlagsUrls.get(language.locale),
          }))
        : []
    ),
  );

  onChangeLanguage(selectedLanguage: string, event: Event): void {
    event.stopPropagation();
    this.changeLangService.changeLang$.next(selectedLanguage);
  }
}
